import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import FileChooser from 'ui-library/FileChooser';
import FileList from 'ui-library/FileList';
import FileRow from 'ui-library/FileRow';

import {SDF_MIME_TYPE} from '../SpreadsheetBulkImportConstants';

interface UploadSDFFormProps {
  file?: File | null;
  onRemoveFile: () => void;
  onSelectFile: (file: File) => void;
}

export default function UploadSDFForm({file, onRemoveFile, onSelectFile}: UploadSDFFormProps): JSX.Element {
  return (
    <div {...getTestProps({component: 'UploadSDFForm', element: 'root'})}>
      <p>
        Upload a SD file containing molecules. All metadata will be parsed from the SD file in addition to a
        molfile and the name parsed from the molfile for each molecule.
      </p>
      <div className="form-group">
        {file ? (
          <FileList>
            <FileRow file={file} onRequestRemove={onRemoveFile} />
          </FileList>
        ) : (
          <FileChooser
            accept={SDF_MIME_TYPE}
            multiple={false}
            onSelectFiles={onSelectFile}
            className="bulkImportModal-sdfChooser"
          />
        )}
      </div>
    </div>
  );
}
